import { LinearGradient } from "@tamagui/linear-gradient";
import { Check } from "@tamagui/lucide-icons";
import { Circle, Paragraph, Subheadline4, YStack } from "@medbillai/ui";
import RatingStars from "./RatingStars";
type Props = {
  rating?: number;
  onChangeRating: (rating: number) => void;
  submitted?: boolean;
  hideCaseClosed?: boolean;
  feedbackScreen?: boolean;
};
export default function CaseRatingCard({
  rating,
  onChangeRating,
  submitted,
  hideCaseClosed,
  feedbackScreen = false
}: Props) {
  return <YStack backgroundColor="$white1" borderColor="$strokeSecondary" borderWidth={feedbackScreen ? 0 : 0.5} borderRadius={feedbackScreen ? 0 : "$6"} overflow="hidden" alignItems="center" paddingVertical="$8" data-sentry-element="YStack" data-sentry-component="CaseRatingCard" data-sentry-source-file="CaseRatingCard.tsx">
      <LinearGradient fullscreen position="absolute" top={0} opacity={0.4} colors={["$lightblue", "#FFFFFF"]} start={{
      x: 0,
      y: 0
    }} end={{
      x: 0,
      y: 0.6
    }} zIndex={0} data-sentry-element="LinearGradient" data-sentry-source-file="CaseRatingCard.tsx" />
      {!hideCaseClosed ? <YStack pb="$2" pt={feedbackScreen ? "$4" : 0} zIndex={1}>
          <Circle size="$4" backgroundColor="$background" borderColor="$strokeSecondary" borderWidth="$0.5" shadowOffset={{
        width: 0,
        height: 4
      }} shadowRadius={4} shadowOpacity={0.1}>
            <Check size="$1" strokeWidth={3} />
          </Circle>
        </YStack> : null}
      <Subheadline4 zIndex={1} data-sentry-element="Subheadline4" data-sentry-source-file="CaseRatingCard.tsx">
        {hideCaseClosed ? "Review Submitted" : "Your case is now closed"}
      </Subheadline4>
      {!hideCaseClosed ? <Paragraph theme="alt1" pt="$1" pb="$2" zIndex={1} px="$8" ta="center">
          {submitted ? "Review submitted" : "How satisfied are you with the help you received?"}
        </Paragraph> : null}
      <YStack pt="$3.5" zIndex={1} data-sentry-element="YStack" data-sentry-source-file="CaseRatingCard.tsx">
        <RatingStars rating={rating} onChangeRating={onChangeRating} disabled={submitted} data-sentry-element="RatingStars" data-sentry-source-file="CaseRatingCard.tsx" />
      </YStack>
    </YStack>;
}